import {types} from '../../types';

const setGroupsAction = (payload) => {
    return {
        type: types.cashier.SET_GROUPS,
        payload,
      }
}

const setGroupsViewAction = (payload) => {
  return {
      type: types.cashier.SET_GROUPS_VIEW,
      payload,
    }
}

const setGetEventHistoryListAction = (payload) => {
  return {
    type: types.cashier.SET_GET_EVENT_HISTORY,
    payload
  }
}

const setGetGamerListAction = (payload) => {
  return {
    type: types.cashier.SET_GAMER_LIST,
    payload
  }
}

const setGetBetAction = (payload) => {
  return {
    type: types.cashier.SET_BET,
    payload
  }
}

const setGetOperatorDetalizationAction = (payload) => {
  return {
    type: types.cashier.SET_OPERATOR_DETALIZATION,
    payload
  }
}

const setGetGamerInformationAction = (payload) => {
  return {
    type: types.cashier.SET_COUNT_GAMER,
    payload
  }
}

const setGetCreditHistoryAction = (payload) => {
  return {
      type: types.cashier.SET_LIST_CREDIT_HISTORY,
      payload,
    }
}

export {
  setGroupsAction as SetGroupsAction,
  setGroupsViewAction as SetGroupsViewAction,
  setGetEventHistoryListAction as SetGetEventHistoryListAction,
  setGetGamerListAction as SetGetGamerListAction,
  setGetBetAction as SetGetBetAction,
  setGetOperatorDetalizationAction as SetGetOperatorDetalizationAction,
  setGetGamerInformationAction as SetGetGamerInformationAction,
  setGetCreditHistoryAction as SetGetCreditHistoryAction
}